import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom'
import 'bootstrap-icons/font/bootstrap-icons.css';
import axios from 'axios';
import App from './App';
import PageScrollHandler from './shared/PageScrollHandler';
import { getUserTokenString, logoutUser } from './shared/auth-utils';

axios.defaults.baseURL = "/api";

axios.interceptors.request.use(config => {
    const token = getUserTokenString();
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, error => Promise.reject(error));

axios.interceptors.response.use(config => config, error => {
    if (error?.response?.status === 401 && ["token-expired", "unauthorized", "no-token"].includes(error.response.data?.code)) {
        window.location.href = logoutUser() + "?expired";
    }
    return Promise.reject(error);
});

ReactDOM.render(
    <StrictMode>
        <BrowserRouter>
            <PageScrollHandler />
            <App />
        </BrowserRouter>
    </StrictMode>,
    document.getElementById('root')
);
